import React, { useState, useEffect } from "react";
import { fetchBranch } from "../../../services/Network";
import NetworkView from "./NetworkView";
import $ from "jquery";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { CircularProgress } from "@material-ui/core";
import ToolTip from "../../../Components/ToolTip/ToolTip";
import "./Network.css";
import { debounce } from "../../../actions/booking";
import CallButton from "./NetworkCall";
import WhatsAppBtn from "./NetworkWhatsap";
import {
  ButtonPrimary,
  ButtonSecondary,
} from "../../../Components/Button/Buttoncontainer";
import { Select2, Select3 } from "../../../Components/Selectcomponents/Select";
import GridContainer from "../../../Components/Grid/GridContainer";
import Grid from "../../../Components/Grid/Grid";

interface NProps {
  onClick: any;
  onChange: any;
}

const Network: React.FC<NProps> = () => {
  const [allBranches, setAllBranches] = useState<any>([]);
  const [loader, setLoader] = useState(true);
  const [state, setState] = useState<any>("");
  const [city, setCity] = useState<any>("");
  const [branch, setBranch] = useState<any>("");
  const [pincode, setPincode] = useState<any>("");
  const [cityOptions, setCityOptions] = useState<any>([]);
  const [stateOptions, setStateOptions] = useState<any>([]);
  const [branchOptions, setBranchOptions] = useState<any>([]);
  const [allCityList, setAllCityList] = useState<any>([]);
  const [displayPrint, setDisplayPrint] = useState(false);

  useEffect(() => {
    setupData();
  }, []);

  useEffect(() => {
    getBranches();
  }, [city, state, pincode, branch]);

  const setupData = () => {
    getCity();
    getState();
    const elem: any = document.getElementById("contnet");
    elem.style.opacity = 0;
    setDisplayPrint(false);
  };

  const getBranches = debounce(() => {
    setLoader(true);
    let payload = {
      state: state.value ? state.value : "",
      city: city.value ? city.value : "",
      pincode: pincode ? pincode : "",
    };

    fetchBranch(payload)
      .then((response) => {
        setAllBranches(response);
        setLoader(false);
        let branchList = [
          {
            label: "All",
            value: "",
            state: state,
            city: city,
          },
        ];
        response.map((ele: any) =>
          ele.branches.map((options: any) =>
            branchList.push({
              label: options.branchName,
              value: options._id,
              state: {
                label: options.address.stateName,
                value: options.address.stateId,
              },
              city: {
                label: options.address.cityName,
                value: options.address.cityId,
              },
            })
          )
        );
        setBranchOptions(branchList);
      })
      .catch(() => {
        setLoader(false);
      });
  }, 300);

  const getCity = () => {
    let payload = {
      state: state.value ? state.value : "",
      city: city.value ? city.value : "",
      pincode: pincode ? pincode : "",
    };
    fetchBranch(payload).then(async (response) => {
      let completeCityList = [
        {
          label: "All",
          value: "",
          state: {
            label: "",
            value: "",
          },
        },
      ];
      response.map((ele: any) =>
        ele.branches.map((options: any) =>
          completeCityList.push({
            label: options.address.cityName,
            value: options.address.cityId,
            state: {
              label: options.address.stateName,
              value: options.address.stateId,
            },
          })
        )
      );

      let uniqueArray = await removeDuplicates(completeCityList, "value");
      setCityOptions(uniqueArray);
      setAllCityList(uniqueArray);
    });
  };
  const removeDuplicates = async (originalArray: any, prop: any) => {
    let newArray: any = [];
    let lookupObject: any = {};

    for (let i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (let i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  };

  const getState = async () => {
    let payload = {
      state: state.value ? state.value : "",
      city: city.value ? city.value : "",
      pincode: pincode ? pincode : "",
    };
    fetchBranch(payload).then(async (response) => {
      let allStateList = [{ label: "All", value: "" }];

      response.map((ele: any) =>
        ele.branches.map((options: any) =>
          allStateList.push({
            label: options.address.stateName,
            value: options.address.stateId,
          })
        )
      );

      let uniqueArray = await removeDuplicates(allStateList, "value");

      setStateOptions(uniqueArray);
    });
  };

  const handleState = (e: any) => {
    setState(e);
    setCityOptions([
      { label: "All", value: "", state: e },
      ...allCityList.filter((b: any) => b.state.value.includes(e.value)),
    ]);
  };
  const handleCity = (e: any) => {
    setCity(e);
  };

  const handleBranch = (e: any) => {
    setBranch(e);
  };
  const handlePincode = (e: any) => {
    setPincode(e.target.value);
  };
  const handleClick = () => {
    setState("");
    setCity("");
    setPincode("");
    setBranch("");
    setCityOptions(allCityList);
  };
  const handleDownload = async () => {
    await setDisplayPrint(true);

    const elem: any = document.getElementById("contnet");

    if (typeof elem === null || elem === "undefined") {
    } else {
      elem.style.opacity = 1;

      const filename = "Kabra-Networks.pdf";
      let HTML_Width: any = $("#contnet").width();
      let HTML_Height: any = $("#contnet").height();

      html2canvas(elem).then((canvas) => {
        let pdf = new jsPDF("p", "pt", [HTML_Width + 100, HTML_Height + 50]);
        pdf.addImage(
          canvas.toDataURL("image/JPG"),
          "JPG",
          10,
          0,
          HTML_Width - 50,
          HTML_Height - 50
        );

        pdf.save(filename);
      });
      elem.style.opacity = 0;

      setDisplayPrint(false);
    }
  };
  const navHeight = document.getElementById("taptapheader");

  return (
    <div
      style={{
        marginTop:
          navHeight && navHeight.clientHeight ? navHeight.clientHeight : 0,
        padding: 15,
      }}
    >
      {/* <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection:"column",
            alignItems: "center",
            border: "1px solid red",
            padding: "5px",
            backgroundColor: "red",
          }}
        >
          <div
            style={{
              fontSize: "44px",
              lineHeight:"normal",
              backgroundColor: "red",
              color: "white",
              margin: "0px",
              padding: "3px",
              fontFamily: 'Italianno , cursive',
              flex:"3"
            }}
          >
            Kabra Express{" "}
          </div>
          <div
            style={{
              // fontSize: "x-large",
              color: "red",
              // margin: "0px",
              // padding: "3px",
              // fontFamily: "ui-serif",
              backgroundColor: "white",
              flex:"1"
            }}
          >
            Logistics Pvt. Ltd.
          </div>
        </div>
      </div> */}
      <div style={{display:"flex",justifyContent:"center"}}>
      <img src="../kabraExpress_logo.png" className="kabra_logo " width={"396px"} style={{maxWidth:"100%",padding:"7px"}} />

      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h3 style={{ fontSize: "x-large" }}>Gst No : 24AAGCK6871L1Z2</h3>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ maxWidth: "50%", padding: "2%" }}>
          <img src="../Eicher.jpeg" style={{ maxWidth: "80%" }} />
        </div>
        <div style={{ maxWidth: "50%", padding: "2%" }}>
          <img src="../Bus.jpeg" style={{ maxWidth: "80%" }} />
        </div>
      </div>
      {loader && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            right: "50%",
            margin: "-35px -35px 0px 0px",
            width: 70,
            height: 70,
          }}
        >
          <CircularProgress />
        </div>
      )}
      <GridContainer>
        <Select3
          placeholder="Select State"
          value={state}
          onChange={(e: any) => handleState(e)}
          options={stateOptions}
        />
        <Select3
          placeholder="Select city"
          value={city}
          onChange={(e: any) => {
            handleCity(e);
            setState(e.state);
          }}
          options={cityOptions}
        />

        <Select2
          placeholder="Select Branch"
          value={branch}
          onChange={(e: any) => {
            handleBranch(e);
            setCity(e.city);
            setState(e.state);
          }}
          options={branchOptions}
        />
        <Grid
          xl={2}
          lg={2}
          md={3}
          sm={12}
          xs={12}
          style={{ margin: 5, height: 40 }}
          item
        >
          <input
            type="number"
            placeholder="Pincode"
            style={{
              width: "100%",
              height: 40,
              border: "1px solid #CAD3CE",
              borderRadius: "5px",
            }}
            value={pincode}
            onChange={(e: any) => handlePincode(e)}
          />
        </Grid>
        <Grid xl={1} lg={1} md={2} sm={3} xs={3} style={{ margin: 5 }} item>
          <ButtonPrimary style={{ fontSize: "12px" }} onClick={handleClick}>
            Reset
          </ButtonPrimary>
        </Grid>
        <Grid xl={1} lg={1} md={2} sm={3} xs={3} style={{ margin: 5 }} item>
          <ButtonSecondary
            style={{ fontSize: "12px" }}
            onClick={handleDownload}
          >
            Download
          </ButtonSecondary>
        </Grid>
      </GridContainer>

      <NetworkView
        allbranches={
          branch === "" || branch.label === "All"
            ? allBranches
            : allBranches.map((ele: any) => {
                return {
                  cityName: ele.cityName,
                  _id: ele._id,
                  branches: ele.branches.filter((b: any) =>
                    b.branchName
                      .toUpperCase()
                      .includes(branch.label.toUpperCase())
                  ),
                };
              })
        }
      />

      <div style={{ display: displayPrint ? "block" : "none" }}>
        <div id="contnet">
          <h3 style={{ textAlign: "center" }}>KABRA LOGITECH</h3>
          {allBranches.map((ele: any) => (
            <>
              <h2 style={{ textAlign: "center" }}>{ele.cityName}</h2>
              <table>
                <tbody>
                  {ele.branches.map((branch: any, i: number) => {
                    return (
                      <tr key={i}>
                        <td className="data">
                          {" "}
                          {branch.branchName.toUpperCase()}
                          {branch.operation && branch.operation.booking ? (
                            <ToolTip title="Booking">
                              <img
                                src={"/branch_list.png"}
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  float: "right",
                                }}
                              />
                            </ToolTip>
                          ) : (
                            ""
                          )}
                          {branch.operation && branch.operation.delivery ? (
                            <ToolTip title="Delivery">
                              <img
                                src={"/delivery_list.png"}
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  float: "right",
                                }}
                              />
                            </ToolTip>
                          ) : (
                            ""
                          )}
                        </td>
                        <td className="data">
                          {" "}
                          {branch.address.l1.toUpperCase()}
                          {branch.address.l2.toUpperCase()}
                          {branch.address.pincode}
                        </td>

                        <td className="data">
                          {" "}
                          {branch.pContact}
                          {branch.sContact ? `, ${branch.sContact}` : ""}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          ))}
        </div>
        <div id="elementH"></div>
      </div>
      <WhatsAppBtn />
      <CallButton />
    </div>
  );
};

export default Network;
